import { render, staticRenderFns } from "./tbwjFile.vue?vue&type=template&id=60786216&scoped=true"
import script from "./tbwjFile.vue?vue&type=script&lang=js"
export * from "./tbwjFile.vue?vue&type=script&lang=js"
import style0 from "./tbwjFile.vue?vue&type=style&index=0&id=60786216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60786216",
  null
  
)

export default component.exports